import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './context';

/** Acessa a sessao corrente. Falha alto fora do provedor, que e erro de montagem. */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth precisa estar dentro de AuthProvider.');
  }
  return context;
}
